//=require main.js
//=require pages/designer.js
//=require alertifyjs/build/alertify.js

!function ($, callback) {
    if (typeof $ === 'undefined') {
        $ = require('jquery');
    }

    callback($);

}(window.jQuery, function ($) {
    $(function () {
        // profile
        $('.sliders-profile-thumb').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: '.sliders-profile-gallery',
        });

        $('.sliders-profile-gallery').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            asNavFor: '.sliders-profile-thumb',
            dots: false,
            centerMode: false,
            focusOnSelect: true,
            accessibility: true,
            prevArrow: `
                <div class="contractor-showroom-btn prev inverted">
                    <i class="fa fa-angle-left slider-arrow slider-arrow-prev" aria-hidden="true"></i>
                </div>
            `,
            nextArrow: `
                <div class="contractor-showroom-btn next inverted">
                    <i class="fa fa-angle-right slider-arrow slider-arrow-next" aria-hidden="true"></i>
                </div>
            `,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1
                    }
                }
            ],
        });

        // digital showroom
        $('a[id="pills-showroom-tab"]').on('shown.bs.tab', function () {
            $('.showroom-sliders-thumbnail').slick('refresh');
            $('.showroom-sliders-avatar').slick('refresh');
        });
        $('.showroom-sliders-thumbnail').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: '.showroom-sliders-avatar',
        });

        const sliderAvatar = $('.showroom-sliders-avatar').slick({
            slidesToShow: 6,
            slidesToScroll: 1,
            asNavFor: '.showroom-sliders-thumbnail',
            dots: false,
            centerMode: false,
            focusOnSelect: true,
            accessibility: true,
            prevArrow: `
                <div class="contractor-showroom-btn prev inverted">
                    <i class="fa fa-angle-left slider-arrow slider-arrow-prev" aria-hidden="true"></i>
                </div>
            `,
            nextArrow: `
                <div class="contractor-showroom-btn next inverted">
                    <i class="fa fa-angle-right slider-arrow slider-arrow-next" aria-hidden="true"></i>
                </div>
            `,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ],


        });

        sliderAvatar.on('init', function (slick) {
            $(slick.$slides.get(0)).addClass('current-slide');
        });

        sliderAvatar.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            const currentSlider = $(slick.$slides.get(currentSlide)).data('name');
            $('.digital-showroom-name').html(currentSlider);
        });

        sliderAvatar.on('afterChange', function (event, slick, currentSlide, nextSlide) {
            const nextSlider = $(slick.$slides.get(currentSlide)).data('name');
            $('.digital-showroom-name').html(nextSlider);
        });
    });

    // $('.general-information-share-icon').click(function () {
    //     window.open('https://www.facebook.com/sharer/sharer.php?u=' + window.location.href,
    //         'facebook-share-dialog',
    //         'width=800,height=600'
    //     );
    //     return false;
    // });

    $('.general-information-share-link .btn-copy').click(function () {
        let temp = $("<input>");
        $("body").append(temp);
        temp.val($('.general-information-share-link #link-share').val()).select();
        document.execCommand("copy");
        temp.remove();

        alertify.set('notifier', 'position', 'top-right');
        alertify.success('Sao chép đường dẫn thành công!');
    });

    // $('.general-information-location').click(function () {
    //     $('.location-show-more').toggle();
    // })

    // video default
    // let idVF = $('.video-feature').data('id');
    // $('.video-others').each((index, item) => {
    //     if ($(item).data('id') == idVF) {
    //         $(item).parent().find('.video-title').css('color', '#006CD9');
    //     }
    // });

    // click video
    $('.video-others, .video-title').click(function () {
        let id = $(this).data('id');
        let title = $(this).data('title');
        let videoFeature = $('.video-feature');

        $(this).parent().find('.video-title').css('color', '#006CD9');
        $('.video-title').not($(this).parent().find('.video-title')).css('color', '#6a6a6a');
        videoFeature.find('iframe').attr('src', 'https://www.youtube.com/embed/' + id + '?autoplay=1');
        videoFeature.find('p.video-feature-title').html(title);
    });

    function stopVideo(player) {
        let vidSrc = player.prop('src');
        player.prop('src', vidSrc);
    }

    $('.nav-pills a').on('shown.bs.tab', function(e) {
        let tabId = e.relatedTarget.attributes['href'].value;
        let tabIframe = $(tabId).find('iframe');
        stopVideo(tabIframe);
    });

    $(".iframe-3d-viewer").mouseover(function () {
        disableScroll();
    })

    $(".iframe-3d-viewer").mouseleave(function () {
        enableScroll();
    })

    const { body, documentElement } = document;
    let { scrollTop } = document.documentElement;

    function disableScroll() {
        scrollTop = documentElement.scrollTop;
        body.style.top = `-${scrollTop}px`;
        body.classList.add("scroll-disabled");
    }

    function enableScroll() {
        body.classList.remove("scroll-disabled");
        documentElement.style.scrollBehavior = "auto";
        documentElement.scrollTop = scrollTop;
        documentElement.style.removeProperty("scroll-behavior");
        body.style.removeProperty("top");
    }

    function changeHandler(e) {
        const sliderIndex = $('.showroom-sliders-avatar').slick('slickCurrentSlide');

        $('.showroom-sliders-avatar').slick('refresh');
        setTimeout(() => {
            $('.showroom-sliders-avatar').slick('slickGoTo', sliderIndex, true);
        }, 500)
    }

    document.addEventListener("fullscreenchange", changeHandler, false);
    document.addEventListener("webkitfullscreenchange", changeHandler, false);
    document.addEventListener("mozfullscreenchange", changeHandler, false);
});


